import { Location } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthService } from 'src/app/services/authentication/auth-service';
import { JwtService } from 'src/app/services/jwt/jwt-service';
import { ModulesService } from 'src/app/services/modules/modules-service';
import { SharedModule } from 'src/app/shared/shared/shared-module';
import { FlagPipe } from '../../../pipes/flags/flag-pipe';

@Component({
  selector: 'app-nav-content',
  imports: [SharedModule, RouterModule, NgScrollbarModule, FlagPipe],
  templateUrl: './nav-content.html',
  styleUrls: ['./nav-content.scss']
})
export class NavContent {
  private location = inject(Location);
  private modulesService = inject(ModulesService);
  private router = inject(Router);
  private authService = inject(AuthService);
  private jwtService = inject(JwtService);

  menuState = input<'expanded' | 'collapsed' | 'hovered'>();
  modules = this.modulesService.getModules();
  wrapperWidth: number = 0;
  windowWidth = window.innerWidth;
  version: any;
  currentYear = new Date().getFullYear();
  NavCollapsedMob = output();

  ngOnInit() {
    this.getVersion();
  }

  get bannerUrl(): string | null {
    return localStorage.getItem('banner');
  }

  get flagCode() {
    return this.jwtService.countryFlagCode$;
  }

  getVersion() {
    this.authService.GetVersion().subscribe({
      next: (results: any) => {
        this.version = results.version;
      }
    });
  }

  toggleMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    item.expanded = !item.expanded;
  }

  isActive(item: any): boolean {
    const currentUrl = this.location.path().replace(/\/$/, '');
    if (item.moduleRoute === 'favourite' && currentUrl === `/sub-navigation/favourite`) {
      return true;
    }
    if (item?.submodules?.length) {
      const parentRoute = `/sub-navigation/${item.moduleRoute}`;
      if (currentUrl === parentRoute || currentUrl.startsWith(parentRoute + '/')) {
        return true;
      }
      return item.submodules.some((child: any) => this.isActive(child));
    }

    if (item.moduleRoute) {
      let directRoute = item.moduleRoute.startsWith('/') ? item.moduleRoute : `/${item.moduleRoute}`;
      return currentUrl === directRoute || currentUrl.startsWith(directRoute + '/');
    }

    return false;
  }

  onMenuClick(menu: any) {
    // if (menu.moduleCode === 'dashboard') {
    //   this.router.navigate(['/dashboard']);
    // } else {
    this.modulesService.setSelectedModule(menu);
    this.router.navigate(['/sub-navigation', menu.moduleRoute]);
    // }
  }
}
